// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", () => {

    const swiper = new Swiper('.carousel', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        // speed: 2000,
        spaceBetween: 30,
        loop: true,
        slidesPerView: 1,
        // loopedSlides: 3,
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 1,
            },
            1280: {
                slidesPerView: 1,
            },
        },
        pagination: {                       //pagination(dots)
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});
